/**
 * Nombre completo de un empleado de `public.Empleados` (`nombre` + `apellido`).
 * @param {Object|null|undefined} employee
 * @returns {string} Cadena vacía si no hay datos.
 */
export const employeeName = (employee) =>
  `${employee?.nombre || ''} ${employee?.apellido || ''}`.trim()
